import { computed } from "vue";

function skillName(skill) {
  return skill.name;
}

function providerKey(provider) {
  return provider.resultGUID ?? provider.id;
}

/**
 * Returns the address groups an info window lists and how each reads. `content` is one result
 * (`{ result }`) or a cluster (`{ addressGroups }`); a single result that is not a location lists
 * its own name, a cluster lists each provider with its specialties.
 */
export function useFinderMapInfoWindow(props) {
  const single = computed(() => Boolean(props.content.result));
  const singleProvider = computed(() => single.value && !props.content.result?.providers);
  const groupClass = computed(() => (single.value ? undefined : "group"));
  const providerLabelClass = computed(() => (single.value ? "content" : "provider-label"));
  function showsSpecialties(provider) {
    return !single.value && Boolean(provider.skills);
  }
  const groups = computed(
    () =>
      props.content.addressGroups ?? [
        { result: props.content.result, providers: props.content.result?.providers ?? [], locations: [] },
      ],
  );
  return { groups, singleProvider, groupClass, providerLabelClass, showsSpecialties, providerKey, skillName };
}
